import { Card, CardContent } from '@/components/ui/card';
import { Printer } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const STATUS_CLASS = {
  paid: 'bg-green-500/10 text-green-400',
  pending: 'bg-yellow-500/10 text-yellow-400',
};

export const RecentOrdersTable = ({ recentOrders }) => {
  const { t } = useLanguage();
  if (!recentOrders || recentOrders.length === 0) return null;

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-4">{t('analytics.recentOrders')}</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left">
                <th className="pb-3 text-muted-foreground font-medium">{t('analytics.orderId')}</th>
                <th className="pb-3 text-muted-foreground font-medium">{t('analytics.customer')}</th>
                <th className="pb-3 text-muted-foreground font-medium">{t('analytics.amount')}</th>
                <th className="pb-3 text-muted-foreground font-medium">Status</th>
                <th className="pb-3 text-muted-foreground font-medium">{t('analytics.date')}</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map((order) => (
                <tr key={order.order_id} className="border-b border-border/50">
                  <td className="py-3 font-mono text-xs">{order.order_id}</td>
                  <td className="py-3">
                    <div>
                      <span className="text-sm">{order.user_name || '-'}</span>
                      {order.user_email && (
                        <span className="block text-xs text-muted-foreground">{order.user_email}</span>
                      )}
                    </div>
                  </td>
                  <td className="py-3 font-mono font-bold text-primary">
                    CHF {(order.total_amount || 0).toFixed(2)}
                  </td>
                  <td className="py-3">
                    <span className={`text-xs px-2 py-0.5 rounded-sm ${STATUS_CLASS[order.status] || 'bg-red-500/10 text-red-400'}`}>
                      {order.status === 'paid' ? t('orders.paid')
                        : order.status === 'pending' ? t('orders.pending')
                          : t('orders.cancelled')}
                    </span>
                    {order.has_prints && (
                      <span className="ml-1 text-xs px-2 py-0.5 rounded-sm bg-blue-500/10 text-blue-400">
                        <Printer className="w-3 h-3 inline" />
                      </span>
                    )}
                  </td>
                  <td className="py-3 text-xs text-muted-foreground">
                    {order.created_at ? new Date(order.created_at).toLocaleDateString() : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
